export { default } from "./ConditionLayout";
